import { useMessages } from './state';

export const AvatarGroupImage = () => {
  const [{ avatarGroupAriaLabel = '' }] = useMessages();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={116}
      height={32}
      fill="none"
      role="img"
      viewBox="0 0 92 26"
      aria-label={avatarGroupAriaLabel}
    >
      <g clipPath="url(#a)">
        <path
          fill="#57D9A3"
          d="M79 25.146c6.708 0 12.146-5.438 12.146-12.146C91.146 6.292 85.708.854 79 .854 72.292.854 66.854 6.292 66.854 13c0 6.708 5.438 12.146 12.146 12.146Z"
        />
        <path
          fill="#79F2C0"
          d="m87.415 21.758-3.483-2.302a.473.473 0 0 0-.24-.078l-4.476-.234-4.476.234a.484.484 0 0 0-.24.078l-3.737 2.47a12.102 12.102 0 0 0 8.236 3.22c3.179 0 6.233-1.29 8.415-3.388h.001Z"
        />
        <path
          fill="#DDB28D"
          d="M82.212 17.486c-.014.303-.028 1.05.132 1.65.064.24.372.332.628.48a.14.14 0 0 1 .04.207c-.503.64-1.336 1.266-2.242 1.675a.239.239 0 0 0-.119.116l-1.237 2.63a.24.24 0 0 1-.435 0l-1.243-2.63a.242.242 0 0 0-.118-.116c-.907-.409-1.739-1.035-2.243-1.675a.137.137 0 0 1 .035-.204c.257-.15.569-.241.632-.482.16-.601.147-1.348.132-1.65H82.212Z"
        />
        <path
          fill="#ECC19C"
          d="M85.29 11.546c.021.602-.98 1.877-1.583 1.899-.601.02-.574-1.22-.594-1.822a1.09 1.09 0 0 1 2.178-.076ZM72.933 11.546c-.02.602.981 1.877 1.583 1.899.602.02.574-1.22.595-1.822a1.09 1.09 0 0 0-2.179-.076h.001Z"
        />
        <path
          fill="url(#b)"
          d="M78.41 18.576c.47.132.968.132 1.439 0 3.722-1.044 3.125-1.416 4.557-7.734.822-3.626.23-7.682-5.277-7.515-5.507-.167-6.1 3.89-5.277 7.515 1.433 6.318.835 6.69 4.558 7.734Z"
        />
        <path
          fill="#ECC19C"
          d="M79.107 16.415c1.029-.036 1.46.478 1.852.178.323-.248.384-.877.148-1.12-.076-.078-.162-.093-.653-.119-.886-.047-.974-.017-1.38-.062-.42-.046-.468-.092-.758-.085-.236.006-.418.045-.736.111-.297.062-.447.094-.499.155-.2.24-.03.911.38 1.153.423.25.731-.18 1.646-.211ZM79.13 13.72c1.538.006 2.633.887 3.397.395.764-.493 1.198-2.358 1.416-3.044.217-.686.22-1.394.12-1.971-.045-.258-.355-.588-.492-1.188a3.596 3.596 0 0 1-.082-.543 8.62 8.62 0 0 0-1.933-.03c-2.51.245-3.647 1.498-5.224 1.024-.336-.1-.859-.33-1.412-.942a3.114 3.114 0 0 0-.427.658 3.336 3.336 0 0 0-.295 1.023c-.12.869.012 1.635.12 1.97.216.687.651 2.553 1.415 3.045s1.859-.39 3.398-.395l-.002-.002Z"
        />
        <path
          fill="url(#c)"
          d="M82.296 15.206a1.486 1.486 0 1 0 0-2.972 1.486 1.486 0 0 0 0 2.972Z"
          opacity={0.36}
          style={{
            mixBlendMode: 'multiply'
          }}
        />
        <path
          fill="url(#d)"
          d="M76.159 15.297a1.486 1.486 0 1 0 0-2.972 1.486 1.486 0 0 0 0 2.972Z"
          opacity={0.36}
          style={{
            mixBlendMode: 'multiply'
          }}
        />
        <path
          fill="#fff"
          d="M79 .854C85.708.854 91.146 6.292 91.146 13c0 6.708-5.438 12.146-12.146 12.146-6.708 0-12.146-5.438-12.146-12.146C66.854 6.292 72.292.854 79 .854ZM79 0a12.912 12.912 0 0 0-9.192 3.808A12.918 12.918 0 0 0 66 13c0 3.472 1.352 6.737 3.808 9.192A12.918 12.918 0 0 0 79 26c3.472 0 6.737-1.352 9.192-3.808A12.914 12.914 0 0 0 92 13c0-3.472-1.352-6.737-3.808-9.192A12.912 12.912 0 0 0 79 0Z"
        />
      </g>
      <path
        fill="#00C7E5"
        d="M57 25.146c6.708 0 12.146-5.438 12.146-12.146C69.146 6.292 63.708.854 57 .854 50.292.854 44.854 6.292 44.854 13c0 6.708 5.438 12.146 12.146 12.146Z"
      />
      <path
        fill="#253858"
        d="M51.02 10.752c-.326.351-1.164 1.351-1.168 2.743-.006 1.478.93 2.632 1.006 2.726.566.685 1.04.825 1.165 1.428.117.566-.163 1.108-.418 1.477 4.27.004 8.541-.18 12.811-.177-.247-.354-.587-.734-.782-1.485-.294-1.136-.029-2.18.37-3.248.748-2.007.89-4-.056-5.964-.803-1.668-2.198-3.044-3.851-3.868a7.75 7.75 0 0 0-2.354-.743 7.675 7.675 0 0 0-1.415-.091 6.252 6.252 0 0 0-1.235.161c-1.36.323-2.654 1.087-3.445 2.26-1.365 2.02-.74 4.381-.626 4.781h-.001Z"
      />
      <path
        fill="#00A3BF"
        d="m60.036 20.031-2.692-.148-2.692.148a3.666 3.666 0 0 0-1.853.624l-2.72 1.839c-.112.078-.213.17-.303.27A12.09 12.09 0 0 0 57 25.146c2.872 0 5.512-.998 7.591-2.666l-2.701-1.826a3.658 3.658 0 0 0-1.854-.624v.001Z"
      />
      <path
        fill="url(#e)"
        d="M60.99 20.676c-.104.132-1.578 1.97-4.02 1.818-2.035-.128-3.194-1.54-3.366-1.757.205-.168.769-.675.945-1.516.273-1.307-.627-2.288-.734-2.4l6.687-.24c-.127.183-.838 1.256-.479 2.577.218.802.723 1.306.966 1.518Z"
      />
      <path
        fill="url(#f)"
        d="M52.193 14.259a1.307 1.307 0 1 0 0-2.613 1.307 1.307 0 0 0 0 2.613Z"
      />
      <path
        fill="url(#g)"
        d="M61.865 14.353a1.307 1.307 0 1 0 0-2.613 1.307 1.307 0 0 0 0 2.613Z"
      />
      <path
        fill="#FFE2D9"
        d="M62.332 12.366a6.872 6.872 0 0 1-1.308 3.673c-.45.612-1.926 2.625-4.076 2.534-1.72-.073-2.857-1.447-3.523-2.252-.438-.529-1.467-1.907-1.664-3.955-.075-.782-.23-2.4.769-3.962.89-1.39 2.646-2.658 4.734-2.511 2.21.154 3.496 1.803 3.823 2.222 1.342 1.72 1.276 3.62 1.245 4.251Z"
      />
      <path
        fill="url(#h)"
        d="M62.34 12.344c-.043-.157-.108-.39-.188-.671-.629-2.216-.95-3.33-1.257-3.61-.558-.508-1.01-.16-3.796-.143-2.688.015-3.177-.306-3.85.234-.804.647-1.083 1.893-1.292 2.827a8.319 8.319 0 0 0-.188 1.363c-.4-2.456.404-4.825 2.125-6.03 1.258-.882 2.71-.935 3.16-.935.452 0 1.904.054 3.16.934 1.723 1.206 2.528 3.575 2.126 6.031Z"
      />
      <path
        fill="#253858"
        d="M51.51 7.95c.325.803 1.287 1.038 2.011 1.215.241.058.75.165 2.465.065 1.889-.11 2.308-.189 3.256-.034.526.085 1.06.313 1.36.806.352.581-.01 1.017.39 1.614.437.653 1.28.744 1.34.75.457.043.815-.096.987-.175 0 0 .007-.01.007-.022.006-.678-.063-2.861-1.668-4.73-1.128-1.314-2.455-1.818-3.216-2.096 0 0-2.3-.84-4.939-.213-.602.143-1.079.329-1.463.746-.445.482-.827 1.34-.53 2.075Z"
      />
      <path
        fill="#fff"
        d="M57 .854C63.708.854 69.146 6.292 69.146 13c0 6.708-5.438 12.146-12.146 12.146-6.708 0-12.146-5.438-12.146-12.146C44.854 6.292 50.292.854 57 .854ZM57 0a12.912 12.912 0 0 0-9.192 3.808A12.914 12.914 0 0 0 44 13c0 3.472 1.352 6.737 3.808 9.192A12.914 12.914 0 0 0 57 26c3.472 0 6.737-1.352 9.192-3.808A12.914 12.914 0 0 0 70 13c0-3.472-1.352-6.737-3.808-9.192A12.914 12.914 0 0 0 57 0Z"
      />
      <g clipPath="url(#i)">
        <path
          fill="#FFAB00"
          d="M35 25.146c6.708 0 12.146-5.438 12.146-12.146C47.146 6.292 41.708.854 35 .854 28.292.854 22.854 6.292 22.854 13c0 6.708 5.438 12.146 12.146 12.146Z"
        />
        <path
          fill="#0C1F41"
          d="M42.772 13.975c-.335-12.783-15.06-13.945-15.372 0-.023 1.056-.032 2.126.57 2.975a2.83 2.83 0 0 0 2.245 1.188c.843.024 8.982-.104 9.952-.095.306.003.64-.047.975-.193.598-.261.922-.704 1.063-.904.6-.848.594-1.917.567-2.971Z"
        />
        <path
          fill="#FFE380"
          d="m38.792 20.516-3.704-.193-3.705.193a.398.398 0 0 0-.198.066L27.828 22.8a12.094 12.094 0 0 0 7.174 2.345c2.685 0 5.232-.895 7.257-2.405l-3.267-2.16a.401.401 0 0 0-.198-.065l-.002.001Z"
        />
        <path
          fill="url(#j)"
          d="M38.569 20.676c-.082.113-1.502 1.999-3.841 1.818-1.894-.147-2.963-1.54-3.123-1.757.18-.134.755-.603.948-1.435.278-1.202-.484-2.128-.573-2.232H37.9c-.04.055-.911 1.264-.36 2.51.285.646.808.975 1.028 1.097v-.001Z"
        />
        <path
          fill="#9C6439"
          d="M30.006 14.17a1.307 1.307 0 1 0 0-2.612 1.307 1.307 0 0 0 0 2.613ZM39.679 14.17a1.307 1.307 0 1 0 0-2.612 1.307 1.307 0 0 0 0 2.613Z"
        />
        <path
          fill="#0C1F41"
          d="M30.348 10.238a36.914 36.914 0 0 1-.047 1.728c-.027.55-.035.464-.062.988-.078 1.466-.003 1.845-.315 2.2-.2.226-.516.394-.639.31-.135-.094.059-.434.133-.954.183-1.28-.24-2.569-.277-2.679-.088-.262-.197-.517-.181-.893.01-.232.032-.727.386-.918.283-.151.686-.06 1.002.218ZM39.262 10.584c.004.973.045 1.88.108 2.715.033.42.116 1.39.652 2.197.056.083.229.344.302.314.088-.037-.063-.46-.133-.954-.183-1.28.24-2.569.277-2.678.088-.262.198-.518.181-.894-.01-.231-.032-.726-.386-.916-.282-.152-.686-.06-1.002.217h.001Z"
        />
        <path
          fill="#9C6439"
          d="M40.145 12.372c-1.018 3.894-2.366 6.599-5.285 6.599s-4.525-3.187-5.285-6.6c-.794-3.557 2.366-6.598 5.285-6.598s6.208 3.074 5.285 6.599Z"
        />
        <path
          fill="#0C1F41"
          d="M30.302 9.324c.182.263-.018.558-.247 1.454-.071.277-.217.85-.26 1.432-.078 1.079.234 1.714.137 1.748-.131.048-.865-1.082-1.025-2.527-.026-.228-.226-2.039.508-2.356.297-.128.718.003.887.247v.002ZM39.413 9.19c-.182.263.018.558.246 1.454.072.277.218.851.26 1.432.078 1.079-.234 1.714-.137 1.749.132.047.865-1.083 1.026-2.528.025-.228.225-2.038-.509-2.355-.297-.129-.717.002-.886.246v.002Z"
        />
        <path
          fill="#0C1F41"
          d="M40.029 9.803c0-.893.239-2.47-.257-3.179-.483-.689-1.782-.53-2.593-.918-.748-.359-1.392-1.5-2.303-1.5-.91 0-1.555 1.142-2.303 1.5-.81.388-2.11.228-2.592.918-.497.708-.257 2.286-.257 3.18.633.139 1.388.246 2.24.252a11.065 11.065 0 0 0 4.695-1.029c.24.218.713.587 1.413.786.89.252 1.637.082 1.956-.01Z"
        />
        <path
          fill="#fff"
          d="M35 .854C41.708.854 47.146 6.292 47.146 13c0 6.708-5.438 12.146-12.146 12.146-6.708 0-12.146-5.438-12.146-12.146C22.854 6.292 28.292.854 35 .854ZM35 0a12.912 12.912 0 0 0-9.192 3.808A12.912 12.912 0 0 0 22 13c0 3.472 1.352 6.737 3.808 9.192A12.914 12.914 0 0 0 35 26c3.472 0 6.737-1.352 9.192-3.808A12.914 12.914 0 0 0 48 13c0-3.472-1.352-6.737-3.808-9.192A12.918 12.918 0 0 0 35 0Z"
        />
      </g>
      <g clipPath="url(#k)">
        <path
          fill="#6554C0"
          d="M13 25.146c6.708 0 12.146-5.438 12.146-12.146C25.146 6.292 19.708.854 13 .854 6.292.854.854 6.292.854 13c0 6.708 5.438 12.146 12.146 12.146Z"
        />
        <path
          fill="#998DD9"
          d="m16.58 19.21-3.236-.178-3.234.178a4.408 4.408 0 0 0-2.228.75l-3.03 2.048a12.103 12.103 0 0 0 8.149 3.139c3.136 0 6.251-1.3 8.437-3.41l-2.63-1.778a4.402 4.402 0 0 0-2.228-.75Z"
        />
        <path
          fill="#403294"
          d="M19.31 21.105c-.441-2.005-.336-3.538-.156-4.571.222-1.278.801-3.2.263-4.12-.07-.121-.393-.622-.532-1.36a3.695 3.695 0 0 1-.06-.485l-11.54-.562a5.019 5.019 0 0 0-.647 1.59c-.225 1.059-.03 1.922.024 2.192.602 2.934-1.043 5.156.044 8.215.268.756.65 1.41 1.085 1.971.053.026.108.053.16.082a12.098 12.098 0 0 0 5.03 1.088c2.133 0 4.136-.55 5.878-1.515a5.524 5.524 0 0 0 .451-2.527v.002Z"
        />
        <path
          fill="url(#l)"
          d="M17.145 21.269c-.108.138-1.645 2.054-4.19 1.896-2.122-.132-3.332-1.606-3.512-1.832.214-.174.802-.704.986-1.581.285-1.363-.654-2.387-.765-2.505l6.972-.25c-.132.192-.874 1.31-.5 2.688a3.272 3.272 0 0 0 1.009 1.584Z"
        />
        <path
          fill="url(#m)"
          d="M7.285 10.445c.04.451.08.902.118 1.354-.21.646-1.658 5.317 1.058 8.922.415.55 2.406 3.194 5.149 2.948 2.432-.219 3.891-2.555 4.117-2.933.501-.835.723-1.773 1.166-3.65.26-1.097.413-1.746.466-2.615.057-.917.02-2.353-.57-4.107l-11.504.08Z"
        />
        <path
          fill="#B08874"
          d="m8.444 9.8.091 1.044c-.109.915-.182 2.29.093 3.926.19 1.124.973 2.327 1.546 3.22.18.28.974 2.15 3.168 2.002 1.807-.121 2.49-1.433 2.8-1.914.152-.232 1.008-1.341 1.293-3.159.183-1.167.32-2.956-.08-5.18l-8.91.061Z"
        />
        <path
          fill="#403294"
          d="M8.663 9.89c.867-1.007 2.103-1.404 2.455-1.517.166-.053 2.9-.889 4.726.517.782.603.868 1.21 2.365 2.487.384.328.716.577.945.741.164-.503.37-1.357.23-2.372-.357-2.594-2.748-4.592-5.18-5.117a6.485 6.485 0 0 0-3.768.317c-2.451 1.02-3.318 3.276-3.442 3.618-.832 2.274-.046 4.234.139 4.664.053-.268.137-.652.27-1.11.163-.56.262-.89.472-1.263.066-.117.335-.438.788-.966v.001Z"
        />
        <path
          fill="#E4B69D"
          d="M18.546 12.603c-.01.072-.02.144-.032.215-.252 1.464-1.935 5.976-5.584 5.976-2.822 0-5.204-4.056-5.41-6.19-.078-.816-.24-2.504.803-4.132.928-1.45 2.759-2.772 4.937-2.62 2.305.162 3.645 1.88 3.986 2.318.949 1.217 1.495 2.885 1.3 4.433Z"
        />
        <path
          fill="#5243AA"
          d="M11.299 8.758c2.019-.583 3.75.197 4.282.468.936.48 1.572 1.135 1.891 1.468.517.541.873 1.064 1.107 1.457.15-.457.336-1.23.21-2.15-.325-2.35-2.492-4.161-4.694-4.637a5.879 5.879 0 0 0-3.415.288c-.294.122-2.31 1.002-3.12 3.278a5.651 5.651 0 0 0-.157 3.188c.215-.405.56-.963 1.093-1.532.45-.478 1.341-1.406 2.803-1.829Z"
        />
        <path
          fill="#fff"
          d="M13 .854C19.708.854 25.146 6.292 25.146 13c0 6.708-5.438 12.146-12.146 12.146C6.292 25.146.854 19.708.854 13 .854 6.292 6.292.854 13 .854ZM13 0a12.912 12.912 0 0 0-9.192 3.808A12.918 12.918 0 0 0 0 13c0 3.472 1.352 6.737 3.808 9.192A12.914 12.914 0 0 0 13 26c3.472 0 6.737-1.352 9.192-3.808A12.914 12.914 0 0 0 26 13c0-3.472-1.352-6.737-3.808-9.192A12.918 12.918 0 0 0 13 0Z"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={79.129}
          x2={79.129}
          y1={18.448}
          y2={3.416}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#253858" />
          <stop offset={1} stopColor="#42526E" />
        </linearGradient>
        <linearGradient
          id="e"
          x1={57.296}
          x2={57.296}
          y1={16.694}
          y2={22.473}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBBEAE" />
          <stop offset={0.64} stopColor="#FFE2D9" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={50.886}
          x2={53.499}
          y1={12.952}
          y2={12.952}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE2D9" />
          <stop offset={1} stopColor="#EBBEAE" />
        </linearGradient>
        <linearGradient
          id="g"
          x1={60.559}
          x2={63.172}
          y1={13.046}
          y2={13.046}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBBEAE" />
          <stop offset={1} stopColor="#FFE2D9" />
        </linearGradient>
        <linearGradient
          id="h"
          x1={57.055}
          x2={57.055}
          y1={12.344}
          y2={5.379}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0D0B4" />
          <stop offset={0.11} stopColor="#E1C5AD" />
          <stop offset={0.33} stopColor="#BAA89B" />
          <stop offset={0.63} stopColor="#7C797F" />
          <stop offset={0.99} stopColor="#273959" />
          <stop offset={1} stopColor="#253858" />
        </linearGradient>
        <linearGradient
          id="j"
          x1={35.087}
          x2={35.087}
          y1={22.506}
          y2={17.069}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9C6439" />
          <stop offset={1} stopColor="#875731" />
        </linearGradient>
        <linearGradient
          id="l"
          x1={13.294}
          x2={13.294}
          y1={17.116}
          y2={23.143}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBBEAE" />
          <stop offset={0.64} stopColor="#FFE2D9" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={13.104}
          x2={13.104}
          y1={23.685}
          y2={10.364}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8575D7" />
          <stop offset={0.15} stopColor="#6758BA" />
          <stop offset={0.29} stopColor="#5143A5" />
          <stop offset={0.43} stopColor="#443698" />
          <stop offset={0.55} stopColor="#403294" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M66 0h26v26H66z" />
        </clipPath>
        <clipPath id="i">
          <path fill="#fff" d="M22 0h26v26H22z" />
        </clipPath>
        <clipPath id="k">
          <path fill="#fff" d="M0 0h26v26H0z" />
        </clipPath>
        <radialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(82.316 13.738) scale(1.48803)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD5C4" />
          <stop offset={0.1} stopColor="#FED4C3" stopOpacity={0.98} />
          <stop offset={0.22} stopColor="#FDD4C2" stopOpacity={0.92} />
          <stop offset={0.36} stopColor="#FCD4C1" stopOpacity={0.82} />
          <stop offset={0.51} stopColor="#FAD3BF" stopOpacity={0.67} />
          <stop offset={0.66} stopColor="#F7D2BC" stopOpacity={0.49} />
          <stop offset={0.83} stopColor="#F4D1B9" stopOpacity={0.27} />
          <stop offset={0.99} stopColor="#F0D0B6" stopOpacity={0} />
          <stop offset={1} stopColor="#F0D0B6" stopOpacity={0} />
        </radialGradient>
        <radialGradient
          id="d"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(76.171 13.829) scale(1.48804)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD5C4" />
          <stop offset={0.1} stopColor="#FED4C3" stopOpacity={0.98} />
          <stop offset={0.22} stopColor="#FDD4C2" stopOpacity={0.92} />
          <stop offset={0.36} stopColor="#FCD4C1" stopOpacity={0.82} />
          <stop offset={0.51} stopColor="#FAD3BF" stopOpacity={0.67} />
          <stop offset={0.66} stopColor="#F7D2BC" stopOpacity={0.49} />
          <stop offset={0.83} stopColor="#F4D1B9" stopOpacity={0.27} />
          <stop offset={0.99} stopColor="#F0D0B6" stopOpacity={0} />
          <stop offset={1} stopColor="#F0D0B6" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
};
